import { Button, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSurveyControl extends Layout {
    buttonLastRun: Button;
    buttonTestQuery: Button;
    buttonVerifyConnection: Button;
    dataheaderSurveyControl: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    labelQueryStatus: Label;
    labelVerificationStatus: Label;
    sourceTia3plSurveyControl: DataSource;
    sourceTia3plSurveyDetail: DataSource;
    switchIsActive: Switch;
    tabGeneral: Tab;
    tabReports: Tab;
    tableSurveyDetail: Table;
    tabsetSurveyControl: Tabset;
    textboxEmail: Textbox;
    textboxEndDate: Textbox;
    textboxLastRunDate: Textbox;
    textboxStartDate: Textbox;
    textboxSurveyUrl: Textbox;
    textboxToken: Textbox;
}
